import React from "react";
import { colorTwoBright, colorTwoDark } from "../../globalStyles";

const COLORS = {
    lightGreen: colorTwoBright,
    darkGreen: colorTwoDark,
};

interface PolygonNameWithCircleProps {
  circleColor: "lightGreen" | "darkGreen";
  circleWidth: number;
  circleHeight: number;
  children: React.ReactNode;
  isSelect?: boolean;
}

export const PolygonNameWithCircle = ({
    circleColor,
    circleWidth,
    circleHeight,
    children,
    isSelect,
}: PolygonNameWithCircleProps) => {
    return (
        <div
            style={{
                display: "inline-flex",
                alignItems: "center",
                position: "relative",
            }}
        >
            <span
                style={{
                    position: isSelect ? "absolute" : "relative",
                    minWidth: circleWidth,
                    width: circleWidth,
                    height: circleHeight,
                    backgroundColor: COLORS[circleColor],
                    display: "block",
                    borderRadius: "50%",
                    marginRight: 7,
                    zIndex: 1,
                    left: isSelect ? 9 : 0,
                }}
            />
            {children}
        </div>
    );
};
